import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Logo } from "../../components/utils/logo";
import { NAV_LINKS } from "./landing-data";

export function LandingNav() {
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-slate-950/80 backdrop-blur-md">
      <Popover as="div" className="relative">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <a
            href="/"
            className="hidden items-center gap-3 md:flex"
            aria-label="Promang forsiden"
          >
            <Logo color="light" sizeClass="h-9" />
          </a>

          <nav
            className="hidden items-center gap-8 md:flex"
            aria-label="Hovedmeny"
          >
            {NAV_LINKS.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-medium text-slate-300 transition hover:text-white"
              >
                {item.name}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <a
              href="/authentication/login"
              className="rounded-lg px-4 py-2 text-sm font-medium text-slate-200 transition hover:bg-white/5 hover:text-white"
            >
              Logg inn
            </a>
            <a
              href="/authentication/login"
              className="rounded-lg bg-sky-500 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-sky-500/25 transition hover:bg-sky-400"
            >
              Kom i gang
            </a>
          </div>

          <Popover.Button className="ml-auto inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg p-2 text-slate-300 hover:bg-white/5 hover:text-white md:hidden">
            <span className="sr-only">Åpne meny</span>
            <Bars3Icon className="h-6 w-6" aria-hidden />
          </Popover.Button>
        </div>

        <Transition
          as={Fragment}
          enter="duration-150 ease-out"
          enterFrom="opacity-0 -translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 -translate-y-1"
        >
          <Popover.Panel className="absolute inset-x-0 top-full border-b border-white/10 bg-slate-950 px-4 py-4 shadow-xl md:hidden">
            <div className="flex items-center justify-end pb-3">
              <Popover.Button className="rounded-lg p-2 text-slate-400 hover:text-white">
                <span className="sr-only">Lukk meny</span>
                <XMarkIcon className="h-6 w-6" />
              </Popover.Button>
            </div>
            <div className="space-y-1">
              {NAV_LINKS.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-medium text-slate-200 hover:bg-white/5"
                >
                  {item.name}
                </a>
              ))}
            </div>
            <a
              href="/authentication/login"
              className="mt-4 flex w-full items-center justify-center rounded-lg bg-sky-500 py-3 text-sm font-semibold text-white"
            >
              Logg inn
            </a>
          </Popover.Panel>
        </Transition>
      </Popover>
    </header>
  );
}
